import RootState from './RootState';
import {
    Module,
    ActionTree,
    ActionContext,
    GetterTree,
    MutationTree,
} from 'vuex';
import { DiamondData } from "@/Helpers/DistributorDataHelper";
import {
    DiamondSupportListClient,
    DsListEntryModel,
  } from "@/diamond-support-api";

export interface DiamondListState {
    DiamondListItems: DiamondData[] | null;
}

export const state: DiamondListState = {
    DiamondListItems: []
};

export const actions: ActionTree<DiamondListState, RootState> = {
    saveDiamondList(
        context: ActionContext<DiamondListState, RootState>,
        DiamondList: DiamondData,
    ) {
        context.commit('setDiamondList', DiamondList);
    },
};

export const getters: GetterTree<DiamondListState, RootState> = {
    diamondList(state: DiamondListState): any {
        return state.DiamondListItems;
    },
};

export const mutations: MutationTree<DiamondListState> = {
    setDiamondList(state: DiamondListState, diamondListItem: DiamondData) {
        for (let value of Object.values(state.DiamondListItems!)) {
            if (value.distributorId == diamondListItem.distributorId) {
                return;
            }
        }
        state.DiamondListItems?.push(diamondListItem);
    }
};

export const diamond: Module<DiamondListState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};